import {Service} from "@/apiServices/Service";

export class PacienteService extends Service {
    constructor() {
        super('paciente/');
    }


    obtenerpacientesPorPlanYNombre(idPlan, nombre) {
        this.onStart();
        return this.http
            .get(this.getUrl(['listar', 'pacientes', 'plan', 'nombre'], {idPlan, nombre}))
            .then(r => this.onData(r))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerpacientesPorPlanYIdPaciente(filtroCertificadoPacientePlan) {
        this.onStart();
        return this.http
            .post(this.getUrl(['listar', 'pacientes', 'plan', 'paciente']), filtroCertificadoPacientePlan)
            .then(r => this.onData(r))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerParentescoPaciente(idPaciente) {
        this.onStart();
        return this.http
            .get(this.getUrl(['perfiles', 'obtenerParentescoPaciente'], {idPaciente}))
            .then(r => this.onData(r))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    llenarListaDetallePaciente(idPaciente) {
        this.onStart();
        return this.http
            .get(this.getUrl(['perfiles', 'obtenerDetallePaciente'], {idPaciente}))
            .then(response => {
                this.data = response.data;
                return this.data;
            })
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerRecibosMovimientosTraspasosPorPaciente(idPaciente) {
        this.onStart();
        return this.http.post(this.getUrl(['listar', 'recibos', 'activos']), idPaciente)
            .then(r => this.onData(r))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerRecibosPorPaciente(idPaciente) {
        this.onStart();
        return this.http.get(this.getUrl(['listar', 'recibos', 'activos'], {idPaciente}))
            .then(r => this.onData(r))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerPacientesPorClinica(idClinica, nombre) {
        this.onStart();
        return this.http.get(this.getUrl(['listar', 'clinica', idClinica], {nombre}))
            .then(r => this.onData(r))
            .then(response => {
                this.data = response.data;
                this.data = this.orderAscData('nombreCompleto');
                return this.data;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerPacientesPorNombreLike(nombre) {
        this.onStart();
        return this.http.get(this.getUrl(['listar', 'nombre'], {nombre}))
            .then(r => this.onData(r))
            .then(response => {
                this.data = response.data;
                this.data = this.orderAscData('nombreCompleto');
                return this.data;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerPacientesPorId(idPaciente) {
        this.onStart();
        return this.http.get(this.getUrl(['listar', 'id'], {idPaciente: [idPaciente]}))
            .then(r => this.onData(r))
            .then(response => {
                this.data = response.data;
                this.data = this.orderAscData('nombreCompleto');
                return this.data;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerPacientePorBusqueda(busqueda) {
        this.onStart();
        return this.http.get(this.getUrl(['perfiles', 'obtenerpacientes', 'activos'], {nombrePaciente: busqueda}))
            .then(r => this.onData(r))
            .then(response => {
                this.data = response.data;
                this.data = this.orderAscData('nombreCompleto');
                return this.data;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerMediosContactoPaciente(idPaciente) {
        this.onStart();
        return this.http.post(this.getUrl(['obtener', 'contactos']), idPaciente)
            .then(r => this.onData(r))
            .then(response => {
                this.data = response.data;
                return this.data;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    guardarMedioContacto(contacto) {
        this.onStart();
        return this.http.put(this.getUrl(['guardar', 'contactos']), contacto)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .then(r => {
                this.toast.info("Datos guardados con exito")
                return r;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerEnfermedades() {
        this.onStart();
        return this.http.get(this.getUrl(['obtener', 'enfermedades']))
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .then(r => {
                return r;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }


}
